import { Routes, Route, Link } from "react-router-dom";
import "./styles.css";
import Album from "./components/Album";
import { useState, useEffect } from "react";
import ReactTouchEvents from "react-touch-events";

import Navigation from './config/new_nav.json'
const ID_PAGES = [];
_id_pages(Navigation, ID_PAGES);

export const IS_PERSO_SITE = window.location.hostname === 'perso.solognot.net' || window.location.search.includes('perso');
if (IS_PERSO_SITE) {
  document.title = 'USA/URSS';
}


export default function App() {

  const [, setEvent] = useState()

  return (
    <ReactTouchEvents onTap={evt => setEvent(evt)}>

      <div id="top">

        {/* Routes nest inside one another. Nested route paths build upon
            parent route paths, and nested route elements render inside
            parent route elements. See the note about <Outlet> below. */}
        <Routes>
          {IS_PERSO_SITE ? (
            <Route path="*" element={<MediaPage category="usa_urss" />} />
          ) : (
            <>
              <Route index element={<Home root={Navigation} />} />
              {ID_PAGES.filter(page => !page.pages).map(page =>
                <Route key={page.id} path={page.id} element={<MediaPage category={page.id} />} />
              )}
              {ID_PAGES.filter(page => !!page.pages).map(page =>
                <Route key={page.id} path={page.id} element={<Home root={page} />} />
              )}
              <Route path="*" element={<Home root={Navigation} />} />
            </>
          )}
        </Routes>
      </div>

    </ReactTouchEvents>

  );
}


function Home({ root }) {

  const [size, setSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    function handleResize() {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const bw = 2200.
  const bh = 2351.

  const w1 = size.width;
  const h1 = size.height;

  const h2 = (bh * w1) / bw;
  const w2 = (bw * h1) / bh;

  let scale = 1.;
  let offW = 0;
  let offH = 0;
  if (h2 < h1) {
    scale = w1 / bw;
    offH = (h1 - h2) / 2.
  } else {
    scale = h1 / bh;
    offW = (w1 - w2) / 2.
  }

  useEffect(() => {
    document.body.classList.add('home');

    return () => {
      document.body.classList.remove('home');
    };
  }, []);

  const pages = root.pages

  if (w1 <= 768) {
    const mobilePlacements = makeMobileGridPlacements(pages);

    return (
      <div className="home-mobile">
        <div className="home-mobile-stage">
          <div className="home-mobile-grid">
            {pages.map((page, index) => (
              <Link
                key={page.id}
                className={"home-mobile-item" + (page.title.toLowerCase() === 'retour' ? ' retour' : '')}
                to={'/' + page.id}
                style={{
                  ...mobilePlacements[index],
                  ...(page.img ? {
                    backgroundImage: `linear-gradient(rgba(241, 236, 230, 0.18), rgba(241, 236, 230, 0.82)), url(https://famille.solognot.net/thumbnail/images/${encodeURIComponent(page.img)})`
                  } : undefined),
                }}
              >
                <span>{page.title}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cartouche-container">
      {pages.map((page, index) =>
        <Cartouche
          key={page.id}
          rect={convert(_makePosition(page, index), offW, offH, scale)}
          name={page.title}
          img={page.img}
          scale={scale}
          target={page.id}
        />
      )}
    </div>
  )
}

function _makePosition(page, index) {
  if (page.position) {
    return page.position
  }

  //x, y, w, h
  return [640, 500 + index * 180, 800, 140]

}

function makeMobileGridPlacements(pages) {
  const columns = 12;
  const rows = 28;
  const bw = 2200;
  const bh = 2351;
  const minRowStart = Math.round(rows * 0.12);
  const usableRows = rows - minRowStart;
  const occupied = new Set();

  const fits = (colStart, rowStart, colSpan, rowSpan) => {
    if (colStart < 1 || rowStart < 1) {
      return false;
    }

    if (colStart + colSpan - 1 > columns) {
      return false;
    }

    for (let row = rowStart; row < rowStart + rowSpan; row += 1) {
      for (let col = colStart; col < colStart + colSpan; col += 1) {
        if (occupied.has(`${row}:${col}`)) {
          return false;
        }
      }
    }

    return true;
  };

  const reserve = (colStart, rowStart, colSpan, rowSpan) => {
    for (let row = rowStart; row < rowStart + rowSpan; row += 1) {
      for (let col = colStart; col < colStart + colSpan; col += 1) {
        occupied.add(`${row}:${col}`);
      }
    }
  };

  const mirroredColumnStart = (x, w, colSpan) => {
    const centerX = x + w / 2;
    const normalizedCenter = centerX / bw;
    const leftSideCenter = normalizedCenter <= 0.5 ? normalizedCenter : 1 - normalizedCenter;
    const snappedCenter = Math.max(0.18, Math.min(0.5, leftSideCenter));
    const mirroredCenter = normalizedCenter <= 0.5 ? snappedCenter : 1 - snappedCenter;
    const centerColumn = Math.round(mirroredCenter * columns);
    const rawStart = centerColumn - Math.ceil(colSpan / 2) + 1;
    const maxColStart = Math.max(1, columns - colSpan + 1);

    return Math.max(1, Math.min(maxColStart, rawStart));
  };

  const placements = [];
  const retourIndexes = [];

  pages.forEach((page, index) => {
    if (page.title.toLowerCase() === 'retour') {
      retourIndexes.push(index);
      placements[index] = null;
      return;
    }

    const [x, y, w, h] = _makePosition(page, index);
    const titleLength = page.title.length;
    const preferredRowStart = Math.max(
      minRowStart,
      Math.min(
        rows,
        minRowStart + Math.round((y / bh) * usableRows)
      )
    );
    const baseColSpan = Math.max(3, Math.round((w / bw) * columns));
    const textColSpan = titleLength > 18 ? 6 : titleLength > 12 ? 5 : titleLength > 8 ? 4 : 3;
    const colSpan = Math.min(columns, Math.max(baseColSpan, textColSpan));
    const rowSpan = Math.max(2, Math.min(3, Math.round((h / bh) * rows) + (titleLength > 18 ? 1 : 0)));

    const maxColStart = Math.max(1, columns - colSpan + 1);
    let colStart = Math.min(mirroredColumnStart(x, w, colSpan), maxColStart);
    let rowStart = preferredRowStart;

    while (!fits(colStart, rowStart, colSpan, rowSpan)) {
      if (colStart < maxColStart) {
        colStart += 1;
      } else {
        colStart = 1;
        rowStart += 1;
      }
    }

    reserve(colStart, rowStart, colSpan, rowSpan);

    placements[index] = {
      gridColumn: `${colStart} / span ${colSpan}`,
      gridRow: `${rowStart} / span ${rowSpan}`,
    };
  });

  let bottomRow = 1;
  occupied.forEach((cell) => {
    const [row] = cell.split(':').map(Number);
    if (row > bottomRow) {
      bottomRow = row;
    }
  });

  retourIndexes.forEach((index, retourOffset) => {
    const rowStart = bottomRow + 1 + retourOffset * 2;
    const rowSpan = 2;
    const colStart = 4;
    const colSpan = 6;
    reserve(colStart, rowStart, colSpan, rowSpan);
    placements[index] = {
      gridColumn: `${colStart} / span ${colSpan}`,
      gridRow: `${rowStart} / span ${rowSpan}`,
    };
  });

  const placementsByRow = new Map();
  placements.forEach((placement, index) => {
    if (!placement || retourIndexes.includes(index)) {
      return;
    }

    const rowStart = Number(placement.gridRow.split(' / ')[0]);
    const rowPlacements = placementsByRow.get(rowStart) || [];
    rowPlacements.push(index);
    placementsByRow.set(rowStart, rowPlacements);
  });

  placementsByRow.forEach((indexes, rowStart) => {
    if (indexes.length !== 2) {
      return;
    }

    const [leftIndex, rightIndex] = indexes.sort((a, b) => {
      const [ax] = _makePosition(pages[a], a);
      const [bx] = _makePosition(pages[b], b);
      return ax - bx;
    });

    const leftSpan = Number(placements[leftIndex].gridColumn.split('span ')[1]);
    const rightSpan = Number(placements[rightIndex].gridColumn.split('span ')[1]);
    const centerGap = 2;
    const leftStart = Math.max(1, 7 - centerGap / 2 - leftSpan);
    const rightStart = Math.min(columns - rightSpan + 1, 7 + centerGap / 2);

    placements[leftIndex] = {
      ...placements[leftIndex],
      gridColumn: `${leftStart} / span ${leftSpan}`,
      gridRow: `${rowStart} / span ${Number(placements[leftIndex].gridRow.split('span ')[1])}`,
    };

    placements[rightIndex] = {
      ...placements[rightIndex],
      gridColumn: `${rightStart} / span ${rightSpan}`,
      gridRow: `${rowStart} / span ${Number(placements[rightIndex].gridRow.split('span ')[1])}`,
    };
  });

  return placements;
}

function Cartouche({ rect, target, name, img, scale }) {


  const styles = {
    left: rect.x + 'px',
    top: rect.y + 'px',
    width: rect.w + 'px',
    height: rect.h + 'px',
    lineHeight: rect.h + 'px',
    color: 'black',
    textAlign: 'center',
    margin: 'auto',
    fontWeight: 'bold',
    fontSize: (parseInt(50 * scale)) + 'px',
  };
  if (img) {
    styles.backgroundImage = `url(https://famille.solognot.net/thumbnail/images/${encodeURIComponent(img)})`
  } 

  const className = "cartouche" + (name.toLowerCase() === 'retour' ? ' retour' : '')
  return (
    <div className={className} style={styles} onClick={() => { document.location.hash = target }}>
      {img ? '' : name}
    </div>
  )

}

function convert(position, offW, offH, scale) {
  const [x, y, w, h] = position;
  let R1 = { x, y, w, h }
  R1.x = parseInt(offW + scale * R1.x)
  R1.y = parseInt(offH + scale * R1.y)
  R1.w = parseInt(scale * R1.w)
  R1.h = parseInt(scale * R1.h)

  return R1;
}

function MediaPage({ category }) {
  useEffect(() => {
    document.body.classList.remove('home');
  }, []);

  return (
    <Album category={category} />
  );

}

function _id_pages(root, collect) {
  if(root.back) return;
  collect.push(root);
  if (root.pages) {
    root.pages.forEach(page => {
      _id_pages(page, collect);
    });
  }

}


export function getParentId(id) {
  return search(Navigation, id);
}

function search(root, id) {
  if (root.pages) {
    for (const page of root.pages) {
      if (page.id === id) {
        return root.id
      }
      const found_id = search(page, id);
      if (found_id) {
        return found_id;
      }
    }
  }
  return null;
}
